import createBrowserHistory from "history/lib/createBrowserHistory";
import { useRouterHistory as createRouterHistory } from "react-router";

export const browserHistory = createRouterHistory(createBrowserHistory)({
  basename: __BASENAME__,
});
